import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { DeleteFormScheme } from "../../../components/Modules/BookingInfo/components/validation.ts";
import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useCancelBooking = (id: string) => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: DeleteFormScheme) => {
      const response = fetch(`${Urls.BookingById}?password=${data.password}`, {
        method: "DELETE",
        slug: {
          bookingId: id,
        },
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["booking-id", id] });
      toast.success("Бронювання успішно скасовано");
    },
    onError: (error) => {
      toast.error(error?.message || "Неможливо скасувати бронювання");
    },
  });
};
